"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var genderString_1 = require("./genderString");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return genderString_1.default; } });
//# sourceMappingURL=index.js.map